import { render, staticRenderFns } from "./resourcePlay.vue?vue&type=template&id=4c8486f5&scoped=true&"
import script from "./resourcePlay.vue?vue&type=script&lang=js&"
export * from "./resourcePlay.vue?vue&type=script&lang=js&"
import style0 from "./resourcePlay.vue?vue&type=style&index=0&id=4c8486f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8486f5",
  null
  
)

export default component.exports